// +----------------------------------------------------------------------
// | Desc:日期库
// +----------------------------------------------------------------------
import Vue from 'vue';

//时间格式化插件
import dayjs from 'dayjs';

// +----------------------------------------------------------------------
// | Desc:当前十位数时间戳
// +----------------------------------------------------------------------
Vue.prototype.$getNowUnix = function () {
    return dayjs().unix();
}

// +----------------------------------------------------------------------
// | Desc:当前年月日
// +----------------------------------------------------------------------
Vue.prototype.$getNowDate = function () {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const date = now.getDate();
    const formattedMonth = month < 10 ? '0' + month : month;
    const formattedDate = date < 10 ? '0' + date : date;
    return `${year}年${formattedMonth}月${formattedDate}日`;
}


// +----------------------------------------------------------------------
// | Desc:时间戳转化为时间格式
// +----------------------------------------------------------------------
// | Param:time时间戳
// | Param:dateFormat 格式化方式 YYYY-MM-DD HH:SS
// +----------------------------------------------------------------------
Vue.prototype.$timeFmt = function (time, dateFormat) {
    if (this.$isblank(time)) {
        return "";
    };
    if(time<1000000000){
        return "";
    };
    if (this.$isblank(dateFormat)) {
        dateFormat = "YYYY-MM-DD HH:mm";
    };

    if (dateFormat == "YYYY-MM-DD HH:MM") {
        dateFormat = "YYYY-MM-DD HH:mm"
    };

    // 转为13位时间戳
    if (time.toString().length === 10) {
        time *= 1000;
    };

    return dayjs(time).format(dateFormat);
}


// +----------------------------------------------------------------------
// | Desc:时间戳转化为友好时间戳戳展示，刚刚，三天前，十天前
// +----------------------------------------------------------------------
// | Param:time时间戳
// +----------------------------------------------------------------------
Vue.prototype.$timeFly = function (date) {
    //转为13位
    date = Number(date) | 0;
    if (date.toString().length == 10) {
        date = Number(date) | 0;
        date = date * 1000;
    };

    const now = dayjs();
    const duration = now.diff(date, 'millisecond');
    const minutes = Math.floor(duration / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    if (duration < 1000 * 60) {
        //刚刚  
        return '刚刚';
    } else if (minutes < 60) {
        //几分钟前  
        return `${Math.floor(minutes)}分钟前`;
    } else if (hours < 24) {
        //今天几点  
        return `今天 ${dayjs(date).format('HH:mm')}`;
    } else if (days < 7) {
        //几天前  
        return `${days}天前`;
    } else if (weeks < 2) {
        //几周前  
        return `${Math.floor(weeks)}周前`;
    } else {
        //完整日期  
        return dayjs(date).format('YYYY-MM-DD HH:mm');
    };
}

// +----------------------------------------------------------------------
// | Desc:将时间字符串转换为十位数时间戳（秒）
// +----------------------------------------------------------------------
Vue.prototype.$timeTmp = function (dateTimeStr, format) {
    try {
        // 如果提供了格式，使用提供的格式解析
        if (format) {
            return Math.floor(dayjs(dateTimeStr, format).valueOf() / 1000);
        } else {
            // 尝试智能解析时间字符串
            return Math.floor(dayjs(dateTimeStr).valueOf() / 1000);
        }
    } catch (error) {
        // 解析失败时抛出错误或返回特定值，如-1表示错误
        console.error('Failed to parse date:', error);
        return -1;
    }
}


// +----------------------------------------------------------------------
// | 根据十位数时间戳获取详细时间信息
// | @param {number} [timestamp] 十位数时间戳（秒），默认为空则获取当前时间
// | @returns {Object} 包含年、月、日、时、分、秒、周几的对象
// +----------------------------------------------------------------------
Vue.prototype.$getTimeDtl = function (timestamp = nullt) {
    // 如果timestamp未提供，获取当前时间戳并转换为十位数
    const targetTime = timestamp !== null ? dayjs.unix(timestamp) : dayjs();

    // 获取时间信息
    const year = targetTime.year();
    const month = targetTime.month() + 1; // 月份从0开始，所以需要+1
    const date = targetTime.date();
    const hour = targetTime.hour();
    const minute = targetTime.minute();
    const second = targetTime.second();
    const weekday = targetTime.day(); // 周日为0，周一是1，以此类推

    // 返回一个包含所有时间信息的对象
    return {
        year,
        month,
        date,
        hour,
        minute,
        second,
        weekday,
    };
}


// +----------------------------------------------------------------------
// | Desc:传两个十位数时间戳判断是否在有效期内
// +----------------------------------------------------------------------
Vue.prototype.$isYouxiaoqiNei = function (timestampStart, timestampEnd) {
    // 获取当前时间戳（以秒为商家）
    const currentTime = Math.floor(Date.now() / 1000);

    // 检查当前时间是否在 timestampStart 和 timestampEnd 之间
    return currentTime >= timestampStart && currentTime <= timestampEnd;
}


// +----------------------------------------------------------------------
// | Desc:友好时间到期提醒
// +----------------------------------------------------------------------
Vue.prototype.$checkDeadline = function (deadline) {
  if (!deadline) {
    return;
  }
  var deadline = parseInt(deadline);
  var oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
  var currentDate = new Date(); // 当前日期
  var targetDate;
  var obj = [];
  obj["txt"] = "";
  obj["BG"] = "";

  // 判断传入的截止日期是时间戳还是日期对象
  if (typeof deadline === "number") {
    if (deadline.toString().length === 10) {
      deadline *= 1000; // 转换为毫秒级别的时间戳
    }
    targetDate = new Date(deadline);
  } else {
    targetDate = new Date(deadline);
  }

  // 设置截止日期的时分秒为 23:59:59
  targetDate.setHours(23, 59, 59, 0);

  // 计算截止日期与当前日期的天数差
  var diffDays = Math.ceil((targetDate - currentDate) / oneDay);

  if (diffDays < 1) {
    obj["txt"] = "到期";
    obj["BG"] = "BG6";
  } else if (diffDays === 1) {
    obj["txt"] = "今日";
    obj["BG"] = "BG6";
  } else if (diffDays === 2) {
    obj["txt"] = "明日";
    obj["BG"] = "BG5";
  } else if (diffDays <= 3) {
    obj["txt"] = "三天";
    obj["BG"] = "BG7";
  } else if (diffDays <= 7) {
    obj["txt"] = "一周";
    obj["BG"] = "BG3";
  } else {
    obj["txt"] = "正常";
    obj["BG"] = "BG4";
  }
  return obj;
};


// +----------------------------------------------------------------------
// | Desc:截止时间提醒
// +----------------------------------------------------------------------
Vue.prototype.$checkDeadlinetype = function (deadline) {
  if (!deadline) {
    return;
  }
  var deadline = parseInt(deadline);
  var oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
  var currentDate = new Date(); // 当前日期
  var targetDate;
  var obj = [];
  obj["txt"] = "";
  obj["BG"] = "";
  // 判断传入的截止日期是时间戳还是日期对象
  if (typeof deadline === "number") {
    if (deadline.toString().length === 10) {
      deadline *= 1000; // 转换为毫秒级别的时间戳
    }
    targetDate = new Date(deadline);
  } else {
    targetDate = new Date(deadline);
  }

  // 设置截止日期的时分秒为 23:59:59
  targetDate.setHours(23, 59, 59, 0);

  // 计算截止日期与当前日期的天数差
  var diffDays = Math.ceil((targetDate - currentDate) / oneDay);

  if (diffDays <= 30) {
    obj["txt"] = "年费";
    obj["BG"] = "BG1";
  } else if (diffDays > 30 && diffDays < 105) {
    obj["txt"] = "费减";
    obj["BG"] = "BG7";
  } else if (diffDays > 105 && diffDays < 135) {
    obj["txt"] = "费减";
    obj["BG"] = "BG7";
  } else {
    obj["txt"] = "其他";
    obj["BG"] = "BG10";
  }
  return obj;
};